import { useEffect, useRef } from "react";

//Save the data for 10 hours by default
export const loadFromStorage = (key, ttl = 1000 * 60 * 60 * 10) => {
    const saved = localStorage.getItem(key);
    if (!saved) return null;

    try {
        const {timestamp, data} = JSON.parse(saved);
        if (Date.now() - timestamp > ttl) {
            localStorage.removeItem(key);
            return null;
        }
        return data;
    } catch(error) {
        console.error("Error reading data from storage", error)
        return null;
    }
}

export const useSaveToStorage = (key, data) => {
    const dataString = JSON.stringify(data);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (!dataString) return;

        if(isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (dataString) {
            const payload = {
                timestamp: Date.now(),
                data: JSON.parse(dataString)
            }
            localStorage.setItem(key, JSON.stringify(payload));
        }
        
    }, [key, dataString])
}